import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import { comparePhotoModule, getResults } from '../ComparePhotoDucks';
import { useParams } from 'react-router-dom';
import PageLoading from '../../../components/PageLoader/PageLoading';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import { ComparePhotoResultColumns } from './ComparePhotoResultColumns';
import Paper from '@material-ui/core/Paper';
import { history } from '../../../_helpers/history';

function ComparePhotoResultPage() {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  let breadCrumbItems = [
    { name: t('breadcrumbs_home'), href: '/' },
    { name: t('breadcrumbs_comparePhoto'), href: '/comparePhoto' },
    { name: t('comparePhoto_columnResult') }
  ];
  const { nextPage } = useTableFilter(filter => {
    dispatch(getResults(id, filter));
  });

  const { loadingResult, contingentIds } = useSelector(
    state => state[comparePhotoModule]
  );
  return (
    <PageLoading loading={loadingResult}>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3" style={{ minWidth: 1800 }}>
        {contingentIds?.length !== 0 && (
          <StaticTablePagination
            columns={ComparePhotoResultColumns({ t, lang: i18n.language })}
            sortable={false}
            data={contingentIds?.content || []}
            onClickLoadMore={() => nextPage()}
            totalElements={contingentIds?.totalElements || 0}
            onClickRow={row =>
              history.push({
                pathname: `${id}/${row.original['firstContingentId']}/${
                  row.original['secondContingentId']
                }`,
                state: {
                  secondContingentPhotoUrl: row.original['secondContingentPhotoUrl'],
                  firstContingentPhotoUrl: row.original['firstContingentPhotoUrl']
                }
              })
            }
            rowBgColor={({ row }) => {
              const value = row?.similarityPercentage;
              if (typeof value !== 'number') return undefined;
              if (value >= 90) {
                return '#ff4d4d55';
              }
              if (value >= 80) {
                return '#fff17666';
              }
              return undefined;
            }}
            loading={loadingResult}
          />
        )}
      </Paper>
    </PageLoading>
  );
}

export default ComparePhotoResultPage;
